import React from "react";
import MUIErrorText from "../MUIErrorText/MUIErrorText";
import { AppTheme } from "../../theme/App.theme";

const CustomTextArea = ({
  value,
  onChange,
  disabled,
  onBlur,
  onKeyDown,
  placeholder = "",
  maxLength = 500,
  error = false,
  helperText = "",
  style = {},
  containerStyle = {},
  name,
  id,
  rows = 5,
}) => {
  return (
    <div style={{ width: "100%", ...containerStyle }}>
      <div style={{ position: "relative" }}>
        <textarea
          name={name}
          id={id}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          disabled={disabled}
          onKeyDown={onKeyDown}
          placeholder={placeholder}
          maxLength={maxLength}
          rows={rows}
          style={{
            width: "100%",
            border: error ? "1.5px solid #f15750" : "1.5px solid #E3E3E3",
            borderRadius: 10,
            padding: "10px",
            fontSize: 16,
            color: disabled && 'rgba(0, 0, 0, 0.38)',
            resize: "none",
            outline: "none",
            boxSizing: "border-box",
            fontFamily: "inherit",
            background: disabled
              ? AppTheme.DISABLED_FIELD_COLOR
              : AppTheme.PRIMARY_WHITE,  
            ...style,
          }}
        />
        <span
          className="px-2"
          style={{
            position: "absolute",
            right: 0,
            bottom: 6,
            fontSize: 11,
            fontWeight: 700,
            padding: "8px",
            color: AppTheme.PRIMARY_BLACK,
            backgroundColor: AppTheme.PRIMARY_WHITE,
            borderRadius: "4px",
            border: `1px solid ${AppTheme.BORDER_COLOR}`,
            pointerEvents: "none",
          }}
        >
          {value?.length || 0}/{maxLength}
        </span>
      </div>
      {helperText && <MUIErrorText ErrorMessage={helperText} />}
    </div>
  );
};

export default CustomTextArea;
